module.exports = __webpack_public_path__ + "static/media/portfolio2014About.be8da8b8.jpg";